/**
 * Converts the URL to the GROWMARK, Inc. standard for versioned API calls.
 * NOTE: this likely will not apply or be useful for non-GMK api services
 */
export const versioned = {
    request: (client) => async (config) => {
        //get base url
        const { baseURL } = config || {};
        if (!baseURL) {
            console.warn('[@growmark/axios]: no base url supplied to the request. versioned config only works with base url.');
            return config;
        }
        //breakout version segment from other parts of the url
        const urlSegments = baseURL.split('/');
        const versionSegment = urlSegments.pop();
        if (versionSegment?.indexOf?.('v') !== 0) {
            console.warn('[@growmark/axios]: base url has no version segment. versioned config only works with version patterns "vX.X.X"');
            return config;
        }
        //make new version
        const newVersionSegment = versionSegment.replace(/\./ig, '_');
        urlSegments.push(newVersionSegment);
        //return new base url
        const newBaseURL = urlSegments.join('/');
        return { ...config, baseURL: newBaseURL };
    }
};
//# sourceMappingURL=versioned.js.map